import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import ReceiptCard from "./ReceiptCard";

export default function OrderStatusPage() {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f4f6f5", p: 3 }}>
      <Grid container spacing={3}>
        {/* LEFT SIDE – NORMAL PAGE CONTENT */}
        <Grid item xs={12} md={7}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Typography variant="h5" fontWeight={600} mb={2}>
                Order Status
              </Typography>

              <Typography>
                This is your normal desktop / mobile layout.
              </Typography>

              <Typography mt={1}>
                • Desktop → left content + right receipt  
                • Mobile → stacked view  
                • Receipt is just a preview
              </Typography>

              <Typography mt={2} color="text.secondary">
                You can add buttons, steps, order tracking,
                customer support, etc here.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* RIGHT SIDE – RECEIPT */}
        <Grid item xs={12} md={5}>
          <ReceiptCard />
        </Grid>
      </Grid>
    </Box>
  );
}
